import { reportsApi } from 'Api/axios/reports-api';
import { useEffect, useState } from 'react';
import { EmployeeCoursesReportFilterI, EmployeeCoursesReportI, EmployeeCoursesReportTotalsI } from 'types';
import type { ReportsPaginationI } from 'Pages/reports/components/ReportsDataGrid/types';

const defaultTotals: EmployeeCoursesReportTotalsI = {
  totalCourses: 0,
  completedCourses: 0,
  pendingCourses: 0,
  approvedEvaluations: 0,
  totalTrainingHours: 0,
};

interface Props {
  employeeId: string;
  init?: boolean;
}

const useEmployeeCoursesReportApi = ({ employeeId, init = false }: Props) => {
  const [data, setData] = useState<Array<EmployeeCoursesReportI>>([]);
  const [pagination, setPagination] = useState<ReportsPaginationI | null>(null);
  const [totals, setTotals] = useState<EmployeeCoursesReportTotalsI>(defaultTotals);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>(null);

  const fetchEmployeeCourses = async (id: string, filters: EmployeeCoursesReportFilterI) => {
    setLoading(true);
    const response = await reportsApi.readCoursesByEmployee(id, filters);
    setLoading(false);
    setData(response.data ?? []);
    setPagination(response.pagination ?? null);
    setError(response.error);
  };

  const fetchEmployeeCoursesTotals = async (id: string) => {
    setLoading(true);
    const response = await reportsApi.readCoursesByEmployeeTotals(id);
    setLoading(false);
    setTotals(response.data ?? defaultTotals);
    setError(response.error);
  };

  useEffect(() => {
    if (init) {
      fetchEmployeeCourses(employeeId, { page: 1, pageSize: 15 });
      fetchEmployeeCoursesTotals(employeeId);
    }
  }, [init]);

  return {
    data,
    pagination,
    totals,
    loading,
    error,
    fetchEmployeeCourses,
    fetchEmployeeCoursesTotals,
  };
};

export default useEmployeeCoursesReportApi;
